import { formatDisplayDate } from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.helpers';

interface DeferredReasonBoxProps {
  note: string;
  deferredDate: string | undefined;
}

const DeferredReasonBox = ({ note, deferredDate }: DeferredReasonBoxProps) => (
  <div
    className="flex flex-col gap-1 rounded-md border border-navy-200 bg-gray-100 p-3"
    data-testid="deferred-reason-box"
  >
    <div className="flex items-center justify-between text-xs font-medium text-gray-500">
      <span>Reason</span>
      <span>Deferred {formatDisplayDate(deferredDate)}</span>
    </div>
    <p className="text-sm font-medium text-gray-700">{note}</p>
  </div>
);

export default DeferredReasonBox;
